export default "__VITE_ASSET__DYxjZkis__"